module.exports = __webpack_public_path__ + "img/loader-circular-1.8a7630ca.gif";